import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { CiStar } from "react-icons/ci";
import { FaStar } from "react-icons/fa";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
const tableHead = ["employee", "date", "calls / revenue week", "Actions"];

// Output: "12/09/2025, 15:14:57" (example in DD/MM/YYYY, HH:MM:SS IST)

const getFollowupMessage = (list) => {
  if (list[list.length - 1]?.received_by?.[0].name) {
    return `Last connected to ${list[list.length - 1]?.received_by[0].name}`;
  }
  return "N/A";
};
const SalesPerformanceTable = ({ data = [] }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/sales-analytics/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            return (
              <tr key={item?.id}>
                <td>
                  {item?.salesPersonName}
                  <br />
                  {item?.allottedMobileNumber}
                </td>
                <td style={{ maxWidth: "200px" }}>{item?.date}</td>
                <td>
                  {item?.callsMadeThisWeek} /{" "}
                  {roundOffCost(item?.totalRevenueClosedWeek)}
                </td>
                <td>
                  <CustomViewButton onClick={() => goToView(item.id)} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SalesPerformanceTable;
